import React from "react";
import { Formik, Form, Field, ErrorMessage, getIn } from "formik";
import CustomDatePicker from "components/CustomDatePicker";
import { toast } from "react-toastify";

const ApplicationForm = ({
  setFieldValue,
  relations,
  countries,
  addMemBeship,
  values,
  setValues,
  isLast,
  formIndex,
  mem,
  removeMemForm,
  validateForm,
  setErrors,
  errors,
  isDynamic = true,
  activeMembership,
  push,
  remove,
  availableSlots = 0,
  // handleClick,
  // handleResetImage
}) => {
  const prefix = isDynamic ? `members[${formIndex}].` : "";

  /* Function to check if all members' forms are filled */
  const areAllMembersFormsValid = () => {
    return values.members.every((member, index) => {
      return (
        member.first_name &&
        member.first_name.trim() !== "" &&
        member.phone_no &&
        member.phone_no.length === 10 &&
        member.email &&
        member.email.trim() !== "" &&
        member.dob &&
        member.sex &&
        member.relation &&
        member.aadhar_number &&
        member.aadhar_number.length === 12
      );
    });
  };

  // Check if we can add more members
  const canAddMoreMembers = () => {
    const numAvailableSlots = Number(availableSlots) || 0;
    const numMembers = values.members?.length || 0;
    if (
      numAvailableSlots > 0 &&
      numMembers < numAvailableSlots &&
      areAllMembersFormsValid()
    ) {
      addMemBeship(values, setValues);
      validateForm();
    } else {
      toast.error(
        `Please fill in all required fields for all members before adding another member.`
      );
    }
  };

  return (
    <div className="card mb-4 mx-4">
      <div className="d-flex justify-content-between align-items-center w-100">
        <h5 className="card-header">Please fill the membership details</h5>

        {isDynamic && formIndex !== 0 && (
          <button className="btn btn-primary mx-2" onClick={removeMemForm}>
            cancel
          </button>
        )}
      </div>

      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-4 col-12">
            <label for="username" className="form-label">
              First Name <span className="invalid-form">*</span>
            </label>
            <Field
              type="text"
              className={`form-control`}
              name={`${prefix}first_name`}
              placeholder="First Name"
              autofocus
              onChange={(e) => {
                if (/^[A-Za-z ]*$/.test(e.target.value)) {
                  setFieldValue(
                    `${prefix}first_name`,
                    e.target.value
                  );
                }
              }}
            />
            {/* {errors?.members && errors?.members?.[formIndex]?.first_name && (
                  <div className="invalid-form"> Required</div>
                )} */}
            <ErrorMessage
              name={`${prefix}first_name`}
              component="div"
              className="invalid-form"
            />
          </div>
          <div className="col-md-4 col-12">
            <label for="username" className="form-label">
              Middle Name
            </label>
            <Field
              type="text"
              className={`form-control`}
              name={`${prefix}middle_name`}
              placeholder="Middle Name"
              autofocus
              onChange={(e) => {
                if (/^[A-Za-z ]*$/.test(e.target.value)) {
                  setFieldValue(`${prefix}middle_name`, e.target.value);
                }
              }}
            />

            <ErrorMessage
              name={`${prefix}middle_name`}
              component="div"
              className="invalid-form"
            />
          </div>
          <div className="col-md-4 col-12">
            <label for="last_name" className="form-label">
              Last Name
            </label>

            <Field
              type="text"
              className={`form-control `}
              name={`${prefix}last_name`}
              placeholder="Last Name"
              autofocus
              onChange={(e) => {
                if (/^[A-Za-z ]*$/.test(e.target.value)) {
                  setFieldValue(`${prefix}last_name`, e.target.value);
                }
              }}
            />

            <ErrorMessage
              name={`${prefix}last_name`}
              component="div"
              className="invalid-form"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <label for="email" className="form-label">
              Email <span className="invalid-form">*</span>
            </label>
            <Field
              type="text"
              className={`form-control`}
              name={`${prefix}email`}
              placeholder="Enter your Email "
              autofocus
              onChange={(e) => {
                if (/^[A-Za-z0-9@.]*$/.test(e.target.value)) {
                  setFieldValue(`${prefix}email`, e.target.value);
                }
              }}
            />

            <ErrorMessage
              name={`${prefix}email`}
              component="div"
              className="invalid-form"
            />
          </div>

          <div className="col-md-6 col-12">
            <label for="phone_no" className="form-label">
              Phone No <span className="invalid-form">*</span>
            </label>
            <Field
              type="text"
              className={`form-control`}
              name={`${prefix}phone_no`}
              placeholder="Enter your  Phone No"
              autofocus
              onChange={(e) => {
                if (/^[0-9]*$/.test(e.target.value)) {
                  setFieldValue(`${prefix}phone_no`, e.target.value);
                }
              }}
              maxLength="10"
            />
            <ErrorMessage
              name={`${prefix}phone_no`}
              component="div"
              className="invalid-form"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <label for="dob" className="form-label">
              DOB <span className="invalid-form">*</span>
            </label>

            <Field
              name={`${prefix}dob`}
              component={CustomDatePicker}
              value={`${prefix}dob`}
            />
            <ErrorMessage
              name={`${prefix}dob`}
              component="div"
              className="invalid-form"
            />
          </div>
          <div className="col-md-6 col-12">
            <label className="form-label" for="sex">
              Gender <span className="invalid-form">*</span>
            </label>
            <Field
              as="select"
              className="select2 form-select"
              name={`${prefix}sex`}
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Field>

            <ErrorMessage
              name={`${prefix}sex`}
              component="div"
              className="invalid-form"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <label for="nationality" className="form-label">
              Country <span className="invalid-form">*</span>
            </label>
            <Field
              as="select"
              className="select2 form-select"
              name={`${prefix}nationality`}
            >
              <option value="">Select</option>
              {countries?.map((country) => {
                return (
                  <option
                    key={country.id}
                    value={country?.id}
                    selected={country?.id === 95}
                  >
                    {country?.name}
                  </option>
                );
              })}
            </Field>
            <ErrorMessage
              name={`${prefix}nationality`}
              component="div"
              className="invalid-form"
            />
          </div>
          <div className="col-md-6 col-12">
            <label className="form-label" for="relation">
              Relation <span className="invalid-form">*</span>
            </label>
            <Field
              as="select"
              className="select2 form-select"
              name={`${prefix}relation`}
            >
              <option value="">Select</option>
              {relations.map((relation, index) => (
                <option key={index} value={relation}>
                  {relation}
                </option>
              ))}
            </Field>
            <ErrorMessage
              name={`${prefix}relation`}
              component="div"
              className="invalid-form"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="aadhar_number">
              Aadhar Number <span className="invalid-form">*</span>
            </label>
            <Field
              type="text"
              className="form-control"
              name={`${prefix}aadhar_number`}
              placeholder="Enter Aadhar Number"
              maxLength="12"
              onChange={(e) => {
                const val = e.target.value;
                if (/^[0-9]*$/.test(val)) {
                  setFieldValue(`${prefix}aadhar_number`, val);
                }
              }}
            />
            <ErrorMessage
              name={`${prefix}aadhar_number`}
              component="div"
              className="invalid-form"
            />
          </div>

          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="user_image">
              User Image
            </label>
            <input
              type="file"
              className="form-control"
              name={`${prefix}user_image`}
              accept="image/png, image/jpeg, image/jpg"
              onChange={(e) => {
                setFieldValue(`${prefix}user_image`, e.currentTarget.files[0]);
              }}
            />
            {getIn(values, `${prefix}user_image`) && (
              <div className="mt-2">
                <img
                  src={
                    typeof getIn(values, `${prefix}user_image`) === "string"
                      ? getIn(values, `${prefix}user_image`)
                      : URL.createObjectURL(getIn(values, `${prefix}user_image`))
                  }
                  alt="User"
                  style={{ maxWidth: "100px", borderRadius: "5px" }}
                />
              </div>
            )}
            <ErrorMessage
              name={`${prefix}user_image`}
              component="div"
              className="invalid-form"
            />
          </div>
        </div>

        {isLast &&
        Number(availableSlots) > 0 &&
        Number(availableSlots) > (values.members?.length || 0) ? (
          <button
            className="btn btn-transparent"
            type="button"
            style={{ color: "#7367F0" }}
            onClick={canAddMoreMembers}
          >
            + Add Member
          </button>
        ) : null}

        

        {/* Show message when current form is incomplete */}
        {/* {isLast &&
          !areAllMembersFormsValid() &&
          values.members.length < activeMembership?.no_of_users && (
            <div className="alert alert-warning mt-3">
              <i className="fas fa-exclamation-triangle me-2"></i>
              Please fill in all required fields for all members before adding
              another member.
            </div>
          )} */}
        {/* <div className="invalid-form">
          {errors?.members && errors?.members?.[formIndex]
            ? "*Please fill the all required filed"
            : ""}
        </div> */}
      </div>
    </div>
  );
};

export default ApplicationForm;
